import { FC, memo } from 'react'
import { Flex, Text } from '@chakra-ui/react'

import { Citizen } from 'CitizenProfile/types'
import { formatDateToString, getInterval } from 'utils/transforms/date'
import { capitalizeString } from 'utils/transforms/string'

type CitizenBirthFields = {
  birthCity: boolean
  birthState: boolean
  birthDate: boolean
  age: boolean
}

type Props = {
  citizen: Citizen | any
  citizenBirthFields: CitizenBirthFields
}

const CitizenCardBirth: FC<Props> = ({ citizen, citizenBirthFields }) => {
  const isAtLeastOneEnabledField = Object.values(citizenBirthFields).some((isTrue) => isTrue)

  return (
    <Flex width="100%" direction="column" gap={1}>
      {isAtLeastOneEnabledField && <Text variant="secondary">Nascimento</Text>}

      <Flex align="center" justify="space-between">
        {citizenBirthFields.birthDate && <Text>{formatDateToString(citizen.birth_certificate_date, true)}</Text>}
        {citizenBirthFields.age && (
          <Text variant="secondary">{getInterval({ start: new Date(), end: citizen.birth_certificate_date })}</Text>
        )}
      </Flex>

      <Flex align="center" justify="space-between">
        {citizenBirthFields.birthCity && <Text>{capitalizeString(citizen.birth_certificate_city)}</Text>}
        {citizenBirthFields.birthState && <Text variant="secondary">{capitalizeString(citizen.birth_certificate_state)}</Text>}
      </Flex>
    </Flex>
  )
}

export default memo(CitizenCardBirth)
